const url = new URL(document.currentScript.src);

// eslint-disable-next-line no-undef
__webpack_public_path__ = (url.origin + (__webpack_public_path__ || "/"));
